import { type NotificationContentModality } from 'primary-schema';
import { type RequireExactlyOne, type ValueOf } from 'type-fest';

import { type Content, EntityKind } from './content.js';
import { type Timing } from './schedule.js';
import { type BaseItem, type NullablePartial } from '../common.js';

interface BaseConfig {
  notificationSchemeId: string;
  notificationTimingId: string;
  notificationContentId: string;
  deletedTimestamp: Date | null;
}

interface Config extends BaseItem, BaseConfig {}

export type UpsertConfig = NullablePartial<
  Omit<BaseConfig, 'notificationSchemeId' | 'deletedTimestamp'>
>;

interface BaseScheme {
  name: string;
  //todo make this not optional once admin ui is removed
  organizationId?: string | null;
  priority: number;
  deletedTimestamp: Date | null;
}

export interface Scheme extends BaseItem, BaseScheme {}

export interface SchemeListEntry extends Scheme {
  kinds: NotificationContentModality[];
  previsitFormTemplates: Record<string, string>;
}
export interface SchemeWithConfigs extends Scheme {
  configs: Config[];
}
export interface ConfigFull extends Omit<Config, 'deletedTimestamp'> {
  timing: Timing;
  content: Content;
  deletedTimestamp: null;
}
export interface SchemeFull extends Scheme {
  configs: ConfigFull[];
}

interface Configs {
  configs: UpsertConfig[];
}
export type CreateValues = NullablePartial<Omit<BaseScheme, 'deletedTimestamp'> & Configs>;
export type UpdateValues = Partial<BaseScheme & Configs>;

export interface CloneValues {
  newName: string;
}
export interface CloneResponse {
  id: string;
}

export type FindAllOptions = Partial<{
  q: string;
  name: string;
  organizationIds: string[];
  includeDeleted: boolean;
  scheduleId: string;
}>;

export type PreviewOptions = RequireExactlyOne<{
  encounterId?: string;
  ehrInformationId?: string;
}>;
export interface PreviewTimingRule {
  start?: Date;
  end?: Date;
  info?: string;
}
export interface PreviewMessage {
  name: string;
  contentKind: NotificationContentModality;
  contentId: string;
  contentName: string;
  timingRules: PreviewTimingRule[];
}

export const PreviewEntityKind = {
  Encounter: EntityKind.Encounter,
  EhrInformation: EntityKind.EhrInformation,
} as const;

export type PreviewEntityKind = ValueOf<typeof PreviewEntityKind>;
export interface PreviewEntityParams {
  entityKind: PreviewEntityKind;
  entityId: string;
}
